import React from "react";
import { ICourierService } from "views/admin/couriers/types/courier.interface";

interface ICourierCtx {
  services: ICourierService[];
  setServices: React.Dispatch<React.SetStateAction<ICourierService[]>>;
}

const CourierContext = React.createContext<ICourierCtx>({} as ICourierCtx);

export default CourierContext;
